import classNames from "classnames";
import React from "react";
import {
    ArticleBodySectionMediaDisplaySize,
    ArticleSectionType,
} from "../../../../__generated__/api";
import Attachment from "../../../../components/attachment/Attachment";
import AttachmentUploader, { ACCEPT_IMAGES, ACCEPT_VIDEO } from "../../../../components/pickers/icon-uploader/AttachmentUploader";
import Button from "../../../../components/theme/button/Button";
import ButtonTabs from "../../../../components/theme/button/ButtonTabs";
import Styles from "../AnswerDetails.module.scss";
import { BaseProps } from "./base";

// eslint-disable-next-line import/prefer-default-export
export function AttachmentBlock({
    section,
    onChange,
    className,
}: BaseProps) {
    if (section.media?.url) {
        return (
            <div className={classNames(Styles["attachment-container"])}>
                <Attachment
                    url={section.media?.url}
                    mimeType={section.media?.mimeType ?? "application/json"}
                    variant="preview"
                    className={classNames(
                        Styles.attachment,
                        Styles[`attachment-size-${section.media?.displaySize?.toLowerCase()}`],
                        !onChange ? Styles["attachment-readonly"] : undefined,
                        className,
                    )}
                    controlsClassName={Styles["attachment-controls"]}
                    controls={onChange ? (
                        <>
                            <ButtonTabs
                                variant="secondary"
                                size="xsmall"
                                value={section.media?.displaySize ?? ArticleBodySectionMediaDisplaySize.Large}
                                values={[
                                    { text: "Small", key: ArticleBodySectionMediaDisplaySize.Small },
                                    { text: "Medium", key: ArticleBodySectionMediaDisplaySize.Medium },
                                    { text: "Large", key: ArticleBodySectionMediaDisplaySize.Large },
                                ]}
                                onChange={value => {
                                    onChange({
                                        ...section,
                                        media: {
                                            ...section.media,
                                            displaySize: value.key as ArticleBodySectionMediaDisplaySize,
                                        },
                                    });
                                }}
                                className={Styles["attachment-size"]}
                            />

                            <Button.Delete
                                size="small"
                                variant="secondary"
                                onClick={() => {
                                    onChange({
                                        ...section,
                                        media: {},
                                    });
                                }}
                            />
                        </>
                    ) : undefined}
                />
            </div>

        );
    }
    return (
        onChange && (
            <AttachmentUploader
                shouldStore
                shouldOpen
                accept={section.type === ArticleSectionType.Image ? ACCEPT_IMAGES : ACCEPT_VIDEO}
                dropClassName={classNames(Styles["attachment-uploader-drop"], className)}
                onChange={(newUrl, mimeType, size, fileName) => {
                    onChange({
                        ...section,
                        media: {
                            ...section.media,
                            url: newUrl,
                            mimeType,
                            size,
                            fileName,
                        },
                    });
                }}
            />
        )
    );
}

AttachmentBlock.defaultProps = {
    onChange: undefined,
};
